import cx from 'classnames';
import { CSSProperties, ReactNode, HTMLAttributes } from 'react';

type TSpinnerProps = {
  className?: string;
  inline?: boolean;
  style?: CSSProperties;
  noMask?: boolean;
};

// move to rio-components
export function Spinner(props: TSpinnerProps) {
  return (
    <div
      style={props.style}
      className={cx('slds-spinner_container', props.className, {
        'slds-spinner_container--inline': props.inline,
        'slds-spinner_container--no-mask': props.noMask
      })}
    >
      <div role="status" className="slds-spinner slds-spinner--medium">
        <span className="slds-assistive-text">Loading</span>
        <div className="slds-spinner__dot-a" />
        <div className="slds-spinner__dot-b" />
      </div>
    </div>
  );
}

export function InlineSpinner(props: TSpinnerProps) {
  return (
    <div style={props.style} className={cx('slds-text-align--center rio-spinner--inline', props.className)}>
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  );
}

export interface ISpinnerOverlayProps extends HTMLAttributes<HTMLDivElement> {
  isLoading?: boolean;
  children?: ReactNode;
}

export const SpinnerOverlay = ({ children, isLoading, className, ...restProps }: ISpinnerOverlayProps) => {
  return (
    <div className={cx('slds-is-relative', className)} {...restProps}>
      {isLoading && <Spinner />}
      {children}
    </div>
  );
};
